import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import CloudflareAnalytics from "./components/CloudflareAnalytics";
import LandingPage from "./pages/LandingPage";
import NotFoundPage from "./pages/NotFoundPage";
import PrivacyPage from "./pages/legal/PrivacyPage";
import TermsPage from "./pages/legal/TermsPage";
import { config } from "./config";

const LEGACY_ADMIN_DESTINATIONS: Record<string, string> = {
  "/admin": "/platform-admin/leads",
  "/admin/login": "/platform-admin",
  "/admin/email": "/platform-admin/email",
  "/admin/analytics": "/platform-admin/analytics",
  "/admin/audit": "/platform-admin/audit",
};

/** Force a document navigation so Pages serves the authenticated app bundle. */
function LegacyAdminRedirect() {
  const destination =
    LEGACY_ADMIN_DESTINATIONS[window.location.pathname] ?? "/platform-admin";
  const target = `${config.appBaseUrl || window.location.origin}${destination}`;

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#71717a",
        fontSize: "0.9rem",
        background: "#09090b",
      }}
    >
      Platform administration has moved. <a href={target}>Open Platform Admin</a>
    </div>
  );
}

export default function App() {
  return (
    <>
      <CloudflareAnalytics />
      <Routes>
        {/* Public marketing + legal */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />

        {/* Standalone admin auth is retired; normal product auth owns access. */}
        <Route path="/admin/*" element={<LegacyAdminRedirect />} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
